import React, { useContext } from 'react';
import { AppContext } from './../context/AppContext';
import dropdownIcon from '../../assets/category-icons/dropdown-icon.svg';

const DropdownCategory = () => {
  const { isNavbarCategoryOpen, setIsNavbarCategoryOpen } = useContext(AppContext);

  return (
    <div className='dropdown-category'>
      <button className='btn-dd-title' onClick={() => setIsNavbarCategoryOpen(prevState => !prevState)} style={isNavbarCategoryOpen ? { filter: 'brightness(60%)' } : {}}>Kategori <span><img src={dropdownIcon} alt='dropdown icon' style={isNavbarCategoryOpen ? { transform: 'rotate(180deg)' } : {}} /></span></button>
      <ul className="dd-menus" style={isNavbarCategoryOpen ? { display: 'block' } : { display: 'none' }}>
        <li className="dd-menu">Belanja <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Travel <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Featured <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Jual <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Top Up & Tagihan <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Entertainment <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
        <li className="dd-menu">Keuangan <span><img src={dropdownIcon} alt='dropdown icon' className='subdropdown-icon' /></span></li>
      </ul>
    </div>
  )
}

export default DropdownCategory
